var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchedulerLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.288 0.216C6.144 0.072 5.968 0 5.76 0C5.552 0 5.376 0.072 5.232 0.216L0.216 5.208C0.072 5.368 0 5.548 0 5.748C0 5.948 0.072 6.128 0.216 6.288L5.232 11.28C5.376 11.424 5.552 11.496 5.76 11.496C5.968 11.496 6.144 11.424 6.288 11.28C6.432 11.136 6.504 10.96 6.504 10.752C6.504 10.544 6.432 10.368 6.288 10.224L1.8 5.76L6.288 1.272C6.432 1.128 6.504 0.952 6.504 0.744C6.504 0.536 6.432 0.36 6.288 0.216Z",
    fill: "#2A4D82"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedulerLeft);
export default __webpack_public_path__ + "static/media/scheduler_left.a1614e4c.svg";
export { ForwardRef as ReactComponent };